import { SkillsBackendIcon, SkillsBracketIcon, SkillsDesignIcon } from "./SkillsElemets";

export const SkillsObj = [
    {skillsTitle:'Frontend Developer',
    skillsSubtitle:'More than 3 years',
    Icon:<SkillsBracketIcon/>,
    skillsDetails:[{
        skillsName:'HTML',
        skillsNumber:'90%',
    },
    {
        skillsName:'CSS',
        skillsNumber:'80%',
    },
    {
        skillsName:'Javascript',
        skillsNumber:'90%',
    },
    {
        skillsName:'React',
        skillsNumber:'90%',
    }
    ]},
    {skillsTitle:'Backend Developer',
    skillsSubtitle:'More than 3 years',
    Icon:<SkillsBackendIcon/>,
    skillsDetails:[{
        skillsName:'Node Js',
        skillsNumber:'80%',
    },
    {
        skillsName:'MySQL',
        skillsNumber:'70%',
    },
    {
        skillsName:'Python',
        skillsNumber:'80%',
    },
    {
        skillsName:'MongoDB',
        skillsNumber:'70%',
    }
    ]},
    {skillsTitle:'More',
    skillsSubtitle:'Extra knowledge',
    Icon:<SkillsDesignIcon/>,
    skillsDetails:[{
        skillsName:'MS Excel',
        skillsNumber:'70%',
    },
    {
        skillsName:'Figma',
        skillsNumber:'40%',
    },
    {
        skillsName:'Photoshop',
        skillsNumber:'60%',
    }
    ]},
];
